import script from "./NetworkSwitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./NetworkSwitch.vue?vue&type=script&setup=true&lang=ts"

import "./NetworkSwitch.vue?vue&type=style&index=0&id=752a96fa&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-752a96fa"]])

export default __exports__